module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("List of Participating Squadrons and Units")]), _vm._v(" "), _c('table', {
    staticClass: "tablef"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vortex")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("28 (AC) Squadron, 33 Squadron, 230 Squadron, RAF Benson; 7 Squadron, 18 Squadron and 27 Squadron, RAF Odiham")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spectre")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("202 Squadron, 60 Squadron, Central Flying School, RAF Shawbury")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dakota")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("Battle of Britain Memorial Flight, RAF Coningsby")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Memorial")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("Battle of Britain Memorial Flight, RAF Coningsby")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Warboys")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("16 Squadron, No 3 Flying Training School, RAF Cranwell")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Swift")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("72(R) Squadron, RAF Linton-On-Ouse")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Snake")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("14 Squadron, RAF Waddington")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zorro")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("47 Squadron, RAF Brize Norton")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Grizzly")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("XXIV Squadron, RAF Brize Norton")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackcat")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("99 Squadron, RAF Brize Norton and 32 Squadron, RAF Northolt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Snapshot")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("5(AC) Squadron, RAF Waddington")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tartan")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("10 Squadron, 101 Squadron, RAF Brize Norton")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Goose")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("51 Squadron, RAF Waddington")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sentry")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("8 Squadron, RAF Waddington")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Aggressor")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("100 Squadron, RAF Leeming")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ninja")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("IV Squadron, RAF Valley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Monster")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("IX(B) Squadron, 31 Squadron, RAF Marham")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gibson")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("617 Squadron, RAF Marham")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Typhoon")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("1(F) Squadron, 2(AC) Squadron, 6 Squadron, RAF Lossiemouth; 3(F) Squadron, 11 Squadron, 29(R) Squadron, RAF Coningsby")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Red Arrows")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("Royal Air Force Aerobatic Team, RAF Scampton")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RAF(U)")])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v("Swanwick")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ddaa72e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List.vue
// module id = 75
// module chunks = 0